import XhrModal from './XhrModal'
export default class Modal
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.DOM.$el.modal = this
        this.options = { ...Modal.prototype.defaults, ...options }
        this.init()
    }

    back() {
        const step = parseInt(this.DOM.$el.dataset.modalStep || 1, 10)
        this.DOM.$el.dataset.modalStep = (step > 1) ? step - 1 : 1
    }

    hide() {
        if (this.isVisible) {
            this.DOM.$el.querySelectorAll('form').forEach($form => $form.reset())
            this.DOM.$el.dataset.modalStep = 1
            this.DOM.$el.classList.remove(this.options.classNameIsVisible)
            this.isVisible = false

            document.body.classList.remove(this.options.classNameHasModal)
            this.DOM.$el.dispatchEvent(new CustomEvent('modal:hide'))
        }
    }

    hideAll() {
        document.querySelectorAll(this.options.selector).forEach($modal => {
            if ($modal !== this.DOM.$el) {
                if ($modal.modal) {
                    $modal.modal.hide()
                }
            }
        })
    }

    init() {
        const eventNameClick = ('ontouchstart' in document.documentElement) ? 'touchstart' : 'click'

        this.DOM.$$back = this.DOM.$el.querySelectorAll(this.options.selectorBack)
        this.DOM.$$hide = this.DOM.$el.querySelectorAll(this.options.selectorHide)
        this.name = this.DOM.$el.dataset.modal
        this.isVisible = false

        // Show modal
        document.querySelectorAll(`[data-modal-show='${this.name}'], a[href='#modal-${this.name}']`).forEach($el => {
            $el.addEventListener(eventNameClick, (e) => {
                e.preventDefault()
                this.show()
            })
        })

        // Hide
        this.DOM.$$hide.forEach($hide => {
            $hide.addEventListener(eventNameClick, (e) => {
                e.preventDefault()
                this.hide()
            })
        })

        // Hide when Esc is pressed
        document.addEventListener('keydown', (e) => {
            if (e.keyCode === 27) {
                this.hide()
            }
        })

        // Hide when overlay is clicked
        this.DOM.$el.addEventListener('click', (e) => {
            if (e.target === e.currentTarget) {
                e.preventDefault()
                this.hide()
            }
        })

        // Back
        this.DOM.$$back.forEach($back => {
            $back.addEventListener('click', (e) => {
                e.preventDefault()
                this.back()
            })
        })

        this.DOM.$el.addEventListener('modal:close', this.hide.bind(this), true)
        this.DOM.$el.addEventListener('modal:redirect', this.redirect.bind(this), true)
    }

    show() {
        document.body.classList.add(this.options.classNameHasModal)
        this.DOM.$el.classList.add(this.options.classNameIsVisible)
        this.isVisible = true

        window.requestAnimationFrame(() => {
            const $autofocus = this.DOM.$el.querySelector('[autofocus]')

            if ($autofocus) {
                $autofocus.focus()
            }

            this.DOM.$el.dispatchEvent(new CustomEvent('modal:show'))
        })
    }

    redirect(e) {
        let a = document.createElement('a')
        a.dataset.xhrModalNew = true
        a.dataset.modalSize = e.detail.size
        a.href = e.detail.url
        new XhrModal(a)
        a.dispatchEvent(new CustomEvent('click'))
    }
}

Modal.prototype.defaults = {
    classNameHasModal: 'has-modal',
    classNameIsVisible: 'is-visible',
    selector: '.js-modal',
    selectorBack: '.js-modalBack',
    selectorHide: '.js-modalHide',
}